export { default, type SpeakersSectionRawProps } from './SpeakersSection';
